export default __webpack_public_path__ + "static/media/soulresonance.dc23bec5.png";